import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { locationShape } from 'react-router'

import { pageLoaded } from 'src/actions'
import {
  hideHud,
  hideTooltip
} from 'src/actions/frontend'

import {
  hostSelector,
  eventSelector
} from 'src/selectors'

import DashboardContainer from 'containers/DashboardContainer'
import HobnobHud from 'components/common/HobnobHud'
import Flier from 'components/details/Flier'
import RSVPModalContainer from 'components/rsvp_modal/RSVPModalContainer'
import MessageModalContainer from 'components/modals/MessageModalContainer'
import ImageModalContainer from 'components/modals/ImageModalContainer'
import LoginModal from 'containers/LoginModal'
import ToastMessagesContainer from 'components/global/ToastMessagesContainer'
import EventSectionsContainer from 'containers/EventSectionsContainer'
import NoticeYellow from 'assets/icons/ico-notice-yellow.png'
import cn from 'classnames'

import styles from './guest-event.scss'

// Receives event. Displays it for a guest
class GuestEvent extends React.Component {
  componentDidMount () {
    this.props.dispatch(pageLoaded())
  }

  _hideTooltip = () => this.props.dispatch(hideTooltip())

  _renderDraftNotice = () => {
    return (
      <div className={styles['draft-notice']}>
        <img src={NoticeYellow} width="20" />
        <span>This is a draft preview, activate it to send your invite! (you can edit it anytime)</span>
      </div>
    )
  }

  render () {
    const {
      dispatch,
      hud,
      host,
      location,
      event
    } = this.props

    const onCloseHud = () => dispatch(hideHud())

    const isDraft = event.state === 'draft'
    return (
      <DashboardContainer>
        <div className={styles['event-container']}>
          {isDraft && this._renderDraftNotice()}

          <div className={cn(styles['guest-event-container'], { [styles['guest-event-container-draft']]: isDraft })}>
            <div className={styles['guest-flier-container']}>
              <Flier event={event} />
            </div>
            <div className={styles['information']}>
              <EventSectionsContainer location={location} />
              <RSVPModalContainer />
              <LoginModal />
              <ImageModalContainer />
              <HobnobHud {...hud} onClose={onCloseHud} host={host} />
              <MessageModalContainer />
              <ToastMessagesContainer />
              <svg style={{ visibility: 'hidden', height: 0, width: 0 }}>
                <defs>
                  <linearGradient id='hobnob-gradient' x1='100%' y1='100%' x2='0%'>
                    <stop stopColor='#55EFCB' />
                    <stop offset='1' stopColor='#99E09C' />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </DashboardContainer>
    )
  }
}

GuestEvent.propTypes = {
  dispatch: PropTypes.func,
  hud: PropTypes.object,
  host: PropTypes.object,
  event: PropTypes.object,
  location: locationShape
}

function mapStateToProps (state) {
  return {
    host: hostSelector(state),
    event: eventSelector(state),
    hud: state.hud
  }
}

export default connect(mapStateToProps)(GuestEvent)



// WEBPACK FOOTER //
// ./src/containers/GuestEvent.jsx